import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import bannerImg from '../Banner/img/0.webp'

const useStyles = makeStyles((theme) => ({
    hero: {
        height: '30vh',
        [theme.breakpoints.down("xs")]: {
            height: '30vh'
        },
        width: '100%',
        background: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${bannerImg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        '&>*': {
            color: '#fff'
        }

    }

}));
const Banner = ({ title }) => {
    const classes = useStyles();
    return (
        <div className={classes.hero}>
            <Typography component="p" variant="h3" align="center" >
                {title}
            </Typography>
        </div>
    )
}

export default Banner